
















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'
import HavingWebRTCMediaMixin from '@/mixins/webrtc/havingWebRTCMediaMixin'

@Component
export default class VideoCallSubScreen extends mixins(HavingWebRTCMediaMixin) {
  @Prop(Object) participant!: MediaComponentProps

  get localVideoActive() {
    return this.$store.getters['videoCallRoom/videoActive']
  }

  get screenActive() {
    return this.participant.isLocal
      ? this.localVideoActive
      : !this.remoteVideoSignalMuted
  }

  handleClickSelectButton() {
    this.$emit('select', this.participant.id)
  }

  mounted() {
    const { stream, muted } = this.participant
    this.initialize(stream, muted)
  }
}
